module.exports = __webpack_public_path__ + "img/t_q5.e7fb7eed.jpeg";